import { FormItem, ISelectOption, Select, SelectMini } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useClients } from 'core/app/AppContext';
import { Group } from 'sections/client-management/entities';
import { entityToSortedSelectOptions } from 'components/utils/getSelectOptions';

interface IProps {
  isMini: boolean;
}
const Container = styled.div<IProps>`
  ${props => (props.isMini ? '' : 'width: 300px;')}
`;

export function GroupSelect({ groupId, onGroupChanged, isMini = false }) {
  const { getGroups } = useClients();
  const { t } = useTranslation('components');

  const groups: ISelectOption<string>[] = entityToSortedSelectOptions<Group>(getGroups());

  const handleGroupChange = (option: ISelectOption<string>) => {
    if (option?.value) {
      onGroupChanged(option.value);
    }
  };
  //Find the ISelectOption associated with this groupId
  const groupValue = groups.find(group => group.value === groupId);
  const inputId = 'group-select';

  return (
    <Container isMini={isMini}>
      <FormItem
        isMini={isMini}
        spacingBelow={false}
        label={`${t('groupSelect.label')}${isMini ? ':' : ''}`}
        for={inputId}
      >
        {isMini ? (
          <SelectMini
            ariaLabel={t('groupSelect.aria')}
            options={groups}
            isSorted={true}
            searchable={true}
            minLength={2}
            onChange={handleGroupChange}
            value={groupValue}
            placeholder={t('groupSelect.placeholder')}
            // TODO:AMAX needs an inputId prop to allow label targetting
          />
        ) : (
          <Select
            ariaLabel={t('groupSelect.aria')}
            options={groups}
            isSorted={true}
            searchable={true}
            minLength={2}
            onChange={handleGroupChange}
            value={groupValue}
            placeholder={t('groupSelect.placeholder')}
            inputId={inputId}
          />
        )}
      </FormItem>
    </Container>
  );
}
